import { render, staticRenderFns } from "./PurchaseAll.vue?vue&type=template&id=0fb8a564&scoped=true"
import script from "./PurchaseAll.vue?vue&type=script&lang=js"
export * from "./PurchaseAll.vue?vue&type=script&lang=js"
import style0 from "./PurchaseAll.vue?vue&type=style&index=0&id=0fb8a564&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8a564",
  null
  
)

export default component.exports